const capitaliseFirstLetter = (input: string): string => {
    return input.length ?
        `${input[0].toUpperCase()}${input.slice(1)}` :
        "";
};

export {
    capitaliseFirstLetter,
};
